import axios from 'axios'

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
}

const getters = {
  isAuthenticated: state => !!state.profile,
  //isPartner: state => !!state.jwt && (JSON.parse(localStorage.getItem('user-id-card')).IsPartner) === true,
  GET_USER_PROFILE: state => state.profile,
}
const mutations = {
  SET_USER_INFO: (state, payload) => {
    state.profile = payload.data
    //localStorage.setItem('user-data', payload.data)
  },
}
const actions = {
  AUTH_CHECK_REQUEST: async (context, payload) => {
    const { data } = await axios.post('/wallet/auth/login', payload, config)
    if (data !== undefined && data.status == 1) {
      context.commit('SET_USER_INFO', data)
    }
    return data
  },
  AUTH_CHECK_CODE: async (context, payload) => {
    const { data } = await axios.post('/wallet/auth/check-code', payload, config)
    return data
  },
  AUTH_PASSWORD_REQUEST: async (context, payload) => {
    const { data } = await axios.post('/wallet/auth/password', payload, config)
    if (data !== undefined && data.status == 1) {
      context.commit('SET_USER_INFO', data)
    }
    return data
  },
  AUTH_RESET_PASSWORD: async (context, payload) => {
    const { data } = await axios.post('/wallet/auth/reset-password', payload, config)
    return data
  },
  AUTH_LOGOUT: async (context) => {
    //localStorage.removeItem('user-data')
    context.commit('SET_USER_INFO', {'data': null})
    window.location.href = window.location.protocol + '//' + window.location.host + '/exit'
  },
  AUTH_IDENTIFY: async (context, payload) => {
    const { data } = await axios.post('/wallet/auth/identify', payload, config)
    return data
  },
}

export default {
  state: () => ({
    //jwt: localStorage.getItem('user-token-card') || '',
    profile: null
  }),
  mutations,
  actions,
  getters
}
